import { Component, OnInit, OnDestroy, Output, ViewChild, ElementRef }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {INewYearReports, INpiasToBeDeleted, INewYearReportsResponse, INPIASMissingFields, INpiasSameSiteDiffLocid} from './new-year-rollover-reports';
import {NewYearReportsService} from './new-year-rollover-reports.service';

import {SystemControl} from '../../../shared/system-control';
import {SystemControlElem} from '../../../shared/system-control-elem';
import {SystemControlService} from '../../../shared/system-control.service';

import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';
import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';
import {Paginator} from 'primeng/primeng';



@Component({
    //templateUrl: 'app/system-management/new-year-rollover/new-year-rollover-steps/new-year-rollover-steps.component.html',
    template: require('./new-year-rollover-reports.component.html'),
    //styleUrls: ["../../../../node_modules/awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css"],
    styles: [require('../../../styles/awesome-bootstrap-checkbox.css')],
    directives: [ROUTER_DIRECTIVES, Dialog, Messages,DataTable,Column, Header, Paginator],
    providers:[ NewYearReportsService]
})


export class NewYearReportsComponent implements OnInit, OnDestroy{
    pageTitle: string = 'New Year Reports';
    errorMessage: string;
    private sub: any;
    newYearRolloverList:any;
    displaySpinner :boolean=false;
    displayDialog:boolean=false;
    npiasToBeDeleted:any;
    npiasToBeInserted:any;
    npiasSameSite:INpiasSameSiteDiffLocid;
    npiasDiffSite:any;
    npiasMissingFields:INPIASMissingFields;
    msgs: Messages[]=[];
    cols: any[];
    locid: string;
    response:INewYearReportsResponse;

   @Output() systemControl:SystemControl;
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _newYearReportsService:NewYearReportsService,
                private _systemControlService:SystemControlService) {
                     this.systemControl = new SystemControl(_systemControlService);
    }

    
    ngOnInit(): void{
    }
     getFacToBeInserted(): void {
          this.displaySpinner = true;
          //console.log("getFacToBeInserted");
          this._newYearReportsService.getNpiasToBeInserted()
                    .subscribe(
                        npiasToBeInserted => this.npiasToBeInserted = npiasToBeInserted,
                        error => this.errorMessage = error,
                        ()=>{
                            this.displaySpinner = false;
                            document.getElementById('facToBeInserted').style.display = 'block';
                            //this.years = _.map(this.traconLocid,'value');
                            //console.log("npiasToBeInserted " + this.npiasToBeInserted);
                        }
                    );
          this.cols = [
            {field: "locid", header: 'Locid'},
            {field: "state", header: 'State'},
            {field: "region", header: 'Region'},
            {field: "facType", header: 'Facility Class'},
            {field: "hubSize", header: 'Hub Size'},
            {field: "iopsNoAdd", header: 'Iops NoAdd'},
            {field: "facLevel", header: 'Facility Level'},
            {field: "centerId", header: 'Center Id'},
            {field: "iopsId", header: 'Iops Id'},
        ]
       
    }
  
    getFacToBedeleted(): void {
          this.displaySpinner = true;
          console.log("getFacToBedeleted");
          this._newYearReportsService.getNpiasToBeDeleted()
                    .subscribe(
                        npiasToBeDeleted => this.npiasToBeDeleted = npiasToBeDeleted,
                        error => this.errorMessage = error,
                        ()=>{
                            this.displaySpinner = false;
                            document.getElementById('facToBedeleted').style.display = 'block';
                            //this.years = _.map(this.traconLocid,'value');
                            //console.log("npiasToBeDeleted " + this.npiasToBeDeleted);
                        }
                    );
          this.cols = [
            {field: "locid", header: 'Locid'},
            {field: "state", header: 'State'},
            {field: "region", header: 'Region'},
            {field: "facType", header: 'Facility Class'},
            {field: "hubSize", header: 'Hub Size'},
            {field: "iopsNoAdd", header: 'Iops NoAdd'},
            {field: "facLevel", header: 'Facility Level'},
            {field: "centerId", header: 'Center Id'},
            {field: "iopsId", header: 'Iops Id'},
        ]
       
    }
    getFacSameSite(): void {
          this.displaySpinner = true;
          //console.log("facSameSite");
          this._newYearReportsService.getNpiasSameSite()
                    .subscribe(
                        npiasSameSite => this.npiasSameSite = npiasSameSite,
                        error => this.errorMessage = error,
                        ()=>{
                            this.displaySpinner = false;
                            document.getElementById('facSameSite').style.display = 'block';
                            //this.years = _.map(this.traconLocid,'value');
                            //console.log("facSameSite " + this.npiasSameSite);
                        }
                    );
          this.cols = [
            {field: "locidTaf", header: 'TAF Locid'},
            {field: "locidNpias", header: 'NPIAS Locid'},
            {field: "siteTaf", header: 'TAF Site'},
            {field: "siteNpias", header: 'NPIAS Site'},
            {field: "regionTaf", header: 'TAF Region'},
            {field: "regionNpias", header: 'NPIAS Region'},
            {field: "AportNameTaf", header: 'TAF Airport Name'},
            {field: "AportNameNpias", header: 'NPIAS Airport Name'},
        ]
       
    }
    getFacDiffSite(): void {
          this.displaySpinner = true;
          //console.log("npiasDiffSite");
          this._newYearReportsService.getNpiasDiffSite()
                    .subscribe(
                        npiasDiffSite => this.npiasDiffSite = npiasDiffSite,
                        error => this.errorMessage = error,
                        ()=>{
                            this.displaySpinner = false;
                            document.getElementById('npiasDiffSite').style.display = 'block';
                            //this.years = _.map(this.traconLocid,'value');
                            //console.log("npiasDiffSite " + this.npiasDiffSite);
                        }
                    );
          this.cols = [
            {field: "locidTaf", header: 'TAF Locid'},
            {field: "locidNpias", header: 'NPIAS Locid'},
            {field: "siteTaf", header: 'TAF Site'},
            {field: "siteNpias", header: 'NPIAS Site'},
            {field: "regionTaf", header: 'TAF Region'},
            {field: "regionNpias", header: 'NPIAS Region'},
            {field: "AportNameTaf", header: 'TAF Airport Name'},
            {field: "AportNameNpias", header: 'NPIAS Airport Name'},
        ]
       
    }
    getNpiasMissingFields(): void {
          this.displaySpinner = true;
          //console.log("facMissingFields");
          this._newYearReportsService.getNpiasMissingFields()
                    .subscribe(
                        npiasMissingFields => this.npiasMissingFields = npiasMissingFields,
                        error => this.errorMessage = error,
                        ()=>{
                            this.displaySpinner = false;
                            document.getElementById('facMissingFields').style.display = 'block';
                            //this.years = _.map(this.traconLocid,'value');
                            //console.log("facMissingFields " + this.npiasMissingFields);
                        }
                    );
          this.cols = [
            {field: "locid", header: 'Locid'},
            {field: "region", header: 'Region'},
            {field: "aportName", header: 'Airport Name'},
            {field: "city", header: 'City'},
            {field: "state", header: 'State'},
            {field: "site", header: 'Site'},
            {field: "naspno", header: 'Naspno'},
            {field: "latitude", header: 'Latitude'},
            {field: "longitude", header: 'Longitude'},
        ]
       
    }
    setHistory(): void {
          this.displaySpinner = true;
          //console.log("setDataSetHistory");
          this._newYearReportsService.setLocidHistory()
                    .subscribe(
                        npiasMissingFields => this.npiasMissingFields = npiasMissingFields,
                        error => this.errorMessage = error,
                        ()=>{
                            this.displaySpinner = false;
                            document.getElementById('setDataSetHistory').style.display = 'block';
                            //this.years = _.map(this.traconLocid,'value');
                            //console.log("setDataSetHistory " + this.npiasMissingFields);
                        }
                    );
          this.cols = [
            {field: "locid", header: 'Locid'},
        ]
       
    }
    onRowSelect(event) {
        this.locid = event.data.locid;
        this.displayDialog = true;
    }
    delete(){
         let params = {
            locId: this.locid

        }
         this._newYearReportsService.deleteNpiasLocid(params) 
         .subscribe(
                response => {
                    this.response = response;
                   // console.log("response: "+  this.response.message + " Error string index:"+  this.response.message.indexOf("Error") );
                    if( this.response.message.indexOf("Error")>=0){
                        this.displayDialog = false;
                        this.msgs.push({severity:'error', summary:'Error Message', detail: this.response.message});
                        console.error( this.response.message);
                    }
                    else{
                        this.displayDialog = false;
                        this.msgs.push({severity:'info', summary:'Info Message', detail: this.response.message});
                    }
                },
                error => {
                    this.displayDialog = false;
                    this.errorMessage = "An error occured while trying to update the facility.";
                    console.error(error);
                }
            );
    }
    hideNpiasLocidToBeDeleted(){
        document.getElementById('facToBedeleted').style.display = 'none';
    }
    hideNpiasLocidToBeInserted(){
        document.getElementById('facToBeInserted').style.display = 'none';
    }
    hideNpiasLocidSameSite(){
        document.getElementById('facSameSite').style.display = 'none';
    }
    hideNpiasLocidDiffSite(){
        document.getElementById('facDiffSite').style.display = 'none';
    }
    hideNpiasMissingFields(){
        document.getElementById('facMissingFields').style.display = 'none';
    }
    hideSetHistory(){
        document.getElementById('setDataSetHistory').style.display = 'none';
    }
    insert(){
         let params = {
            locId: this.locid
        }
         this._newYearReportsService.insertNpiasLocid(params) 
         .subscribe(
                response => {
                    this.response = response;
                    //console.log("response: "+  this.response.message + " Error string index:"+  this.response.message.indexOf("Error") );
                    if( this.response.message.indexOf("Error")>=0){
                        this.displayDialog = false;
                        this.msgs.push({severity:'error', summary:'Error Message', detail: this.response.message});
                        this.getFacToBedeleted();
                        console.error( this.response.message);
                    }
                    else{
                        this.displayDialog = false;
                        this.msgs.push({severity:'info', summary:'Info Message', detail: this.response.message});
                    }
                },
                error => {
                    this.displayDialog = false;
                    this.errorMessage = "An error occured while trying to update the facility.";
                    console.error(error);
                }
            );
    }
    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/new-year-rollover/new-year-rollover-reports/new-year-rollover-reports.component.ts
 **/